// extracted by mini-css-extract-plugin
export default {"right_box":"index_right_box_vCw0U","list_box":"index_list_box_cu957"};